'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Actions perform by a user on an expression.
 *
 * @export
 * @enum {number}
 */
var PatternAction = /*#__PURE__*/function (PatternAction) {
  PatternAction[PatternAction["Add"] = 0] = "Add";
  PatternAction[PatternAction["Edit"] = 1] = "Edit";
  PatternAction[PatternAction["Remove"] = 2] = "Remove";
  return PatternAction;
}({});

exports.PatternAction = PatternAction;
